module.exports = __webpack_public_path__ + "fd81d9009262b0bdc333da84edc226b3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/band-peacock.png
// module id = 2157
// module chunks = 0